import PropTypes from "prop-types"
import React from "react"
import BulmaColumns from "./BulmaColumns"

export default function HorizontalTwoColumns(props) {
  return (
    <BulmaColumns className={props.className} style={props.style}>
      {props.leftColWidth !== 0 && (
        <div className={`column is-${props.leftColWidth}`}></div>
      )}
      {props.leftColumn}
      <div className={`column is-${props.middleColWidth}`}></div>
      {props.rightColumn}
      {props.rightColWidth !== 0 && (
        <div className={`column is-${props.rightColWidth}`}></div>
      )}
    </BulmaColumns>
  )
}

HorizontalTwoColumns.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  leftColWidth: PropTypes.number.isRequired,
  middleColWidth: PropTypes.number.isRequired,
  rightColWidth: PropTypes.number.isRequired,
  leftColumn: PropTypes.element,
  rightColumn: PropTypes.element,
}
